<template>
  <!--	노션 링크 : https://www.notion.so/ReservInfoPage-0cd7c8d24f8347569f8c57ffffdbae15 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="optionprogram_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">OPTION PROGRAM</h1>
      <div class="headerimage" />
    </div>

    <div class="container contentDesc">
      <div class="title1">
        <h2>
          <strong>{{ $t('option_title') }}</strong>
        </h2>
        <div class="col-lg-12 text-center" style="margin-bottom: 30px">
          <p style="margin-bottom: 0.5rem">{{ $t('option_desc1') }}</p>
          <p style="font-size: 0.8rem; color: #848484">{{ $t('option_desc2') }}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row d-flex">
        <div v-for="(item, index) in optionprogram_items" :key="index" class="col-lg-4 col-12 mb-4">
          <template>
            <div class="card">
              <router-link :to="item.href">
                <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
              /></router-link>
              <div class="card-body">
                <h5 class="card-title" style="letter-spacing: -0.02rem">{{ $t(item.title) }}</h5>
                <p class="card-text">{{ $t(item.desc) }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Optionprogram',
  data() {
    return {
      optionprogram_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      optionprogram_items: [
        {
          title: 'option_program_title1',
          desc: 'option_program_desc1',
          image: require('@/assets/images/pleisure/option/sutherapy_01.jpg'),
          href: '/p/Sutherapy',
        },
        {
          title: 'option_program_title2',
          desc: 'option_program_desc2',
          image: require('@/assets/images/pleisure/option/omoroviczaspa_01.jpg'),
          href: '/p/Omoroviczaspa',
        },
        {
          title: 'option_program_title3',
          desc: 'option_program_desc3',
          image: require('@/assets/images/pleisure/option/medicalspa_01.jpg'),
          href: '/p/Medicalspa',
        },
        {
          title: 'option_program_title4',
          desc: 'option_program_desc4',
          image: require('@/assets/images/pleisure/option/flowersetting_01.jpg'),
          href: '/p/Flowersetting',
        },
        {
          title: 'option_program_title5',
          desc: 'option_program_desc5',
          image: require('@/assets/images/pleisure/option/shooting_01.jpg'),
          href: '/p/Shooting',
        },
        {
          title: 'option_program_title6',
          desc: 'option_program_desc6',
          image: require('@/assets/images/pleisure/option/snappicture_01.jpg'),
          href: '/p/Snappicture',
        },
        {
          title: 'option_program_title7',
          desc: 'option_program_desc7',
          image: require('@/assets/images/pleisure/option/vonestis_spa_01.jpg'),
          href: '/p/Vonestisspa',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb},
};
</script>

<style lang="scss" scoped>
p,
h1,
h2,
h3,
h4,
h5 {
  word-break: keep-all;
}
li {
  list-style: none;
}
li:before {
  content: 'ㆍ';
  display: inline-block;
  vertical-align: middle;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
.top {
  padding-top: 11rem;
}

.card-text {
  margin-bottom: 13px;
  font-size: 14px;
  opacity: 0.7;
  word-break: keep-all;
}
.card-body {
  height: 10rem;
  padding-top: 12px;
}
td {
  border-bottom: 1px dashed #cdcdcd;
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/option_headerimage.jpg');
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "옵션 프로그램",
    "option_title": "옵션 프로그램",
    "option_desc1": "P-Leisure 고객만을 위한 특별한 혜택! 옵션 프로그램을 할인가에 이용 가능합니다.",
    "option_desc2": "※ 메인 프로그램 이용 시에만 예약 가능합니다.",
    "option_program_title1": "수(水) 테라피",
    "option_program_desc1": "돔 형식의 아쿠아 메디테이션 온수 풀 안에서 진행하는 스트레칭·지압 릴렉싱 프로그램",
    "option_program_title2": "오모로비짜 스파",
    "option_program_desc2": "약 2,000여년 동안 전해온 헝가리 부다페스트 온천수 프리미엄 스킨케어 프로그램",
    "option_program_title3": "메디컬 스파",
    "option_program_desc3": "메디컬과 스파가 융합된 바디&페이셜 트리트먼트 프로그램",
    "option_program_title4": "플라워 세팅",
    "option_program_desc4": "특별한 날, 소중한 분을 위한 플라워 데코레이팅 서비스",
    "option_program_title5": "사격",
    "option_program_desc5": "권총, 소총, 클레이 사격 3종을 안전하고 손쉽게 체험할 수 있는 이색 레저 프로그램",
    "option_program_title6": "스냅 사진",
    "option_program_desc6": "잊지 못할 즐거운 추억을 전문 사진가의 손길로 남겨보세요.",
    "option_program_title7": "본에스티스 스파",
    "option_program_desc7": "일상의 지친 신체와 정신의 궁극적 균형 회복을 도모하는 보다 근본적인 스킨테라피"
  },
  "en": {
    "breadcrumb": "Option Program",
    "option_title": "Option Program",
    "option_desc1": "Special Offer for P-Leiseure customers only! Option programs are available at a discounted price.",
    "option_desc2": "※ Reservations can be made only when using the main program.",
    "option_program_title1": "Water Therapy",
    "option_program_desc1": "Dome-shaped aqua mediation hot pool offers a stretching and acupressure relaxing program.",
    "option_program_title2": "Omorovieza Spa",
    "option_program_desc2": "Budapest hot spring water premium skincare program in Hungary, which has 2,000-year history.",
    "option_program_title3": "Medical Spa",
    "option_program_desc3": "Body & Facial treatment program combining medical treatment with spa.",
    "option_program_title4": "Flower Service",
    "option_program_desc4": "Flower decorating service for precious people on a special day.",
    "option_program_title5": "Shooting",
    "option_program_desc5": "A unique leisure program you can have shooting experience of 3 types of guns (pistol, rifle, and clay shooting) safely and easily.",
    "option_program_title6": "Snap Shot",
    "option_program_desc6": "Keep unforgettable memories with a professional photographer.",
    "option_program_title7": "VONESTIS Spa",
    "option_program_desc7": "Fundamental skin therapy that restores ultimate balance between the body and mind"
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "option_title": "옵션 프로그램",
    "option_desc1": "P-Leisure 고객만을 위한 특별한 혜택! 옵션 프로그램을 할인가에 이용 가능합니다.",
    "option_desc2": "※ 메인 프로그램 이용 시에만 예약 가능합니다.",
    "option_program_title1": "옵션 프로그램",
    "option_program_desc1": "돔 형식의 아쿠아 메디테이션 온수 풀 안에서 진행하는 스트레칭·지압 릴렉싱 프로그램",
    "option_program_title2": "오모로비짜 스파",
    "option_program_desc2": "약 2,000여년 동안 전해온 헝가리 부다페스트 온천수 프리미엄 스킨케어 프로그램",
    "option_program_title3": "메디컬 스파",
    "option_program_desc3": "메디컬과 스파가 융합된 바디&페이셜 트리트먼트 프로그램",
    "option_program_title4": "플라워 세팅",
    "option_program_desc4": "특별한 날, 소중한 분을 위한 플라워 데코레이팅 서비스",
    "option_program_title5": "사격",
    "option_program_desc5": "권총, 소총, 클레이 사격 3종을 안전하고 손쉽게 체험할 수 있는 이색 레저 프로그램",
    "option_program_title6": "스냅 사진",
    "option_program_desc6": "잊지 못할 즐거운 추억을 전문 사진가의 손길로 남겨보세요."
  }
}
</i18n>
